import loadingAnimation from '../loading-animation.vue';
import storyCard from '../common-thread/story-card/story-card.vue';
import { Navigation, Pagination, Lazy, A11y } from 'swiper';
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
import { SpotifyPlacement } from '../enums/strapi';
import spotify from './spotify.vue';

export default {
  name: 'commonThreadArchive',
  components: {
    storyCard,
    spotify,
    Swiper,
    SwiperSlide,
    LoadingAnimation: loadingAnimation,
  },

  data() {
    return {
      filters: {
        videos: false,
        people: false,
        planet: false,
        gear: false,
      },
      initalPageLoad: true,
      isSortOpen: false,
      isTyping: false,
      pageLoading: true,
      pageNumber: 1,
      postsToShow: 24,
      postsToLoad: 24,
      searchQuery: '',
      showAllStories: false,
      showMoreStories: false,
      sortSelected: 'Newest First',
      SpotifyPlacement,
      spotifyPlacement: '',
      spotifyLink: '',
      spotifyImg: '',
      spotifyDesc: '',
      spotifyTitle: '',
      SpotifyPlacement,
      spotifyPlacement: '',
      spotifyLink: '',
      spotifyImg: '',
      spotifyDesc: '',
      spotifyTitle: '',
      stories: [],
      storiesLoading: true,
      storiesMetaData: {},
    };
  },

  computed: {
    displayedStories() {
      return this.stories.slice(0, this.postsToShow);
    },
    defaultQueryParameters() {
      return {
        'populate[category]': '*',
        'populate[heroMedia][populate][0]': 'heroPhoto',
        'pagination[page]': this.pageNumber,
      };
    },
    //builds query params to attach to api request based off user inputs on sorting/filtering/searching
    computedQueryParams() {
      const queryParams = { ...this.defaultQueryParameters };
      //add search by title query
      if (this.searchQuery) {
        queryParams['filters[title][$contains]'] = this.searchQuery;
      }

      // check for any category filters to query by
      let categoryFilters = this.areAnyCategoryFiltersTrue(this.filters);
      //since we can filter by multiple categories, add a query param for each cateogry checked
      if (categoryFilters) {
        categoryFilters.forEach((cat, index) => {
          if (cat === 'videos') {
            queryParams['filters[storyType]'] = 'video';
          } else {
            queryParams[`filters[$or][${index}][category][categoryName][$eq]`] =
              cat;
          }
        });
      }

      //build sorting params (newest by default)
      const sort = this.convertSortSelect(this.sortSelected);
      queryParams.sort = sort;

      return queryParams;
    },
  },
  watch: {
    filters: {
      handler(newFilters, oldFilters) {
        this.pageNumber = 1;
        this.storiesLoading = true;
        this.stories = [];
        this.debounce(this.getStories, 500);
      },
      deep: true,
    },
    searchQuery: {
      handler: function (newQuery) {
        this.pageNumber = 1;
        this.storiesLoading = true;
        this.stories = [];
        this.debounce(this.getStories, 500);
      },
      immediate: false,
    },
    sortSelected: {
      handler(newSort, oldSort) {
        this.pageNumber = 1;
        this.storiesLoading = true;
        this.stories = [];
        this.getStories();
      },
    },
  },
  methods: {
    convertSortSelect(sort) {
      switch (sort) {
        case 'Newest First':
          return 'posted_date:desc';
          break;
        case 'Oldest First':
          return 'posted_date:asc';
          break;
        case 'A to Z':
          return 'title:asc';
          break;
        case 'Z to A':
          return 'title:desc';
          break;
        default:
          //default to newest first
          return 'posted_date:desc';
      }
    },
    //delays api call by half second
    debounce(func, delay) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        func();
      }, delay);
    },
    uncheckFilters(obj) {
      this.searchQuery = '';
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          obj[key] = false;
        }
      }
    },
    // look at which category filters are checked and returns the list to build query parameters
    areAnyCategoryFiltersTrue(obj) {
      const checkedCategories = [];
      for (let key in obj) {
        if (obj[key] === true) {
          checkedCategories.push(key);
        }
      }
      return checkedCategories;
    },
    buildQueryParams() {
      //when we initially land on archive page, we want to check url for any prefiltered search queries
      let searchParam = new URL(window.location.href).searchParams.get(
        'search'
      );
      if (searchParam) {
        this.searchQuery = searchParam;
      } else {
        let categoryParam = new URL(window.location.href).searchParams.get(
          'category'
        );
        let videosParam = new URL(window.location.href).searchParams.get(
          'videos'
        );
        if (categoryParam) {
          this.filters[categoryParam.toLowerCase()] = true;
          this.categoryFilter = categoryParam;
        }
        if (videosParam) {
          this.filters.videos = true;
        }
      }
    },
    //gets the stories to display
    async getStories() {
      //clears url parameters passed over from landing page for cleaner look
      this.clearUrlParams();
      try {
        const res = await axios.get('https://cms.cotopaxi.com/api/stories', {
          params: this.computedQueryParams,
        });
        //if we're not on page 1, add new stories to current stories array
        if (this.computedQueryParams['pagination[page]'] == 1) {
          this.stories = res.data.data;
        } else {
          this.stories = [...this.stories, ...res.data.data];
        }

        this.storiesMetaData = res.data.meta;
        this.getSpotifyInfo();
        this.storiesLoading = false;
      } catch (err) {
        console.error('error fetching data', err);
      }
    },
    clearUrlParams() {
      const currentUrl = new URL(window.location.href);
      // Clears all URL parameters
      currentUrl.search = '';
      // Update the URL without parameters
      window.history.replaceState({}, document.title, currentUrl.href);
    },
    getSpotifyInfo() {
      axios
        .get('https://cms.cotopaxi.com/api/landing-page?populate=*')
        .then((response) => {
          const spotifyData = response.data.data.attributes;
          this.spotifyPlacement = spotifyData.spotifyPlacement;
          if (this.spotifyPlacement === SpotifyPlacement.allPages) {
            this.spotifyLink = spotifyData.spotifyPlaylistLink;
            this.spotifyTitle = spotifyData.spotifyTitle;
            this.spotifyDesc = spotifyData.spotifyDescription;
            if (spotifyData.spotifyImage.data) {
              this.spotifyImg = spotifyData.spotifyImage.data.attributes.url;
            }
          }
        });

      this.pageLoading = false;
    },
    incrementPageNumber() {
      return new Promise((resolve) => {
        this.pageNumber += 1;
        this.postsToShow += this.postsToLoad;
        resolve();
      });
    },

    async getMoreStories() {
      this.showAllStories = true;
      //wait until page number increases before getting more stories
      await this.incrementPageNumber();
      this.getStories();
    },
  },
  mounted() {
    this.buildQueryParams();
    this.getStories();
  },
};
